import {Box, Flex, Stack} from '@mantine/core';
import {BasicPage} from '../../components/basic-page';
import {JobEvaluationPartKit} from './job-evaluation-part-kit';
import {JobEvaluationUpdate} from './job-evaluation-update';
import {JobRepairServicePerformed} from './job-service-repair-performed';
import {PartsList} from './parts-list/parts-list';

type JobEvaluationProps = {
  children?: React.ReactNode;
};

export const JobEvaluation: React.FC<JobEvaluationProps> = () => {
  return (
    <BasicPage p={0} pb={32} maxWidth='97%'>
      <JobEvaluationUpdate />
      <Flex direction='row' gap='lg'>
        <Box mt={16} w='20%'>
          <JobRepairServicePerformed />
        </Box>
        <Box mt={16} w='80%'>
          <Stack>
            <JobEvaluationPartKit />
            <PartsList />
          </Stack>
        </Box>
      </Flex>
    </BasicPage>
  );
};
